import { FC, useEffect, useMemo } from "react";
import styles from "./TagFilter.module.css";
import clsx from "clsx";
import { Tag, Space } from "antd";

import { useAppDispatch, useAppSelector, useQueryParams } from "hooks";
import {
  appendThemeTags,
  getLeftFiler,
  setHost,
  setThemeTags,
} from "store/ducks/filterHackathon/slice";
import { usePopularTag } from "api/master";
import { useHistory } from "react-router";
import { Hidden } from "components/Hidden";

const MAPPING_LENGTH: Record<string, string> = {
  day: "1 – 6 days",
  week: "1 – 4 weeks",
  month: "1+ month",
};

const TagFilter: FC = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { themeTags, eligibility, host, lengths } =
    useAppSelector(getLeftFiler);
  const { data: tagOptions } = usePopularTag();

  const query = useQueryParams();

  useEffect(() => {
    const host = query.get("host");
    const tag = query.get("tag");
    if (tag) dispatch(appendThemeTags(tag as string));
    if (host) dispatch(setHost(host as string));
    history.replace({ search: "" });
  }, []);

  const handleTagChange = (selected: string) => {
    if (themeTags.includes(selected)) {
      return dispatch(setThemeTags(themeTags.filter((x) => x !== selected)));
    }

    dispatch(setThemeTags([...themeTags, selected]));
  };

  const tagDataset = useMemo(() => {
    return tagOptions?.slice(0, 6);
  }, [tagOptions]);

  return (
    <>
      <div className={styles.root}>
        <h3 className={styles.title}>Popular Tags:</h3>

        <Space className="w-100">
          {tagDataset?.map((x) => (
            <Tag
              onClick={() => handleTagChange(x.name)}
              className={clsx(styles.tag, {
                [styles.tagActive]: themeTags.includes(x.name),
              })}
              key={x.name}
            >
              <svg width="6" height="7" viewBox="0 0 6 7" fill="none">
                <circle
                  cx="3"
                  cy="3.5"
                  r="3"
                  fill="#080A25"
                  fillOpacity="0.7"
                />
              </svg>
              {x.name}
            </Tag>
          ))}
        </Space>
      </div>

      <Hidden
        cond={
          !!eligibility ||
          lengths.length !== 0 ||
          !!host ||
          themeTags.length !== 0
        }
      >
        <div className={styles.root_2}>
          <h3 className={styles.title}>Filtered by:</h3>

          <Space wrap>
            {eligibility && (
              <Tag className={clsx(styles.tag, styles.noCursor)}>
                <svg width="6" height="7" viewBox="0 0 6 7" fill="none">
                  <circle
                    cx="3"
                    cy="3.5"
                    r="3"
                    fill="#080A25"
                    fillOpacity="0.7"
                  />
                </svg>
                Match your eligibility
              </Tag>
            )}
            {host && (
              <Tag className={clsx(styles.tag, styles.noCursor)}>
                <svg width="6" height="7" viewBox="0 0 6 7" fill="none">
                  <circle
                    cx="3"
                    cy="3.5"
                    r="3"
                    fill="#080A25"
                    fillOpacity="0.7"
                  />
                </svg>
                Host : {host}
              </Tag>
            )}
            {lengths.length !== 0 && (
              <Tag className={clsx(styles.tag, styles.noCursor)}>
                <svg width="6" height="7" viewBox="0 0 6 7" fill="none">
                  <circle
                    cx="3"
                    cy="3.5"
                    r="3"
                    fill="#080A25"
                    fillOpacity="0.7"
                  />
                </svg>
                Length : {MAPPING_LENGTH[lengths[0]]}
              </Tag>
            )}

            {themeTags.length !== 0 && (
              <Tag className={clsx(styles.tag, styles.noCursor)}>
                <svg width="6" height="7" viewBox="0 0 6 7" fill="none">
                  <circle
                    cx="3"
                    cy="3.5"
                    r="3"
                    fill="#080A25"
                    fillOpacity="0.7"
                  />
                </svg>
                Tags : {themeTags.join(", ")}
              </Tag>
            )}
          </Space>
        </div>
      </Hidden>
    </>
  );
};

export default TagFilter;
